import {
  PRODUCT_CLASS_VIEW_LOADED,
  PRODUCT_CLASS_LISTED_ALL,
  PRODUCT_CLASS_UNLOAD
} from '../actions/productClass/action_types';

const initialStore = { isLoaded: false, productClass: {}, productClasses: [] };

export default function productClass(state = initialStore, action) {
  switch (action.type) {
    case PRODUCT_CLASS_VIEW_LOADED:
      return { ...state, isLoaded: true, productClass: action.payload, productClasses: [] };
    case PRODUCT_CLASS_LISTED_ALL:
      return { ...state, isLoaded: true, productClass: {}, productClasses: action.payload };
    case PRODUCT_CLASS_UNLOAD:
      return { ...initialStore };
    default:
      return state;
  }
}
